define('SageDotCom/DataLayer/Util/htmlHelper',['jquery'], function ($) {

    function htmlHelper() { }

    // find the most prominent text within a chunk of HTML
    htmlHelper.prototype.findTitle = function findTitle(html) {
        var defaultLabel = '(not set)';

        var h1 = $("h1", html).first().text();
        var h2 = $("h2", html).first().text();
        var h3 = $("h3", html).first().text();
        var p = $("p", html).first().text();

        return h1 || h2 || h3 || p || defaultLabel;
    }

    return new htmlHelper();
});
